<template>
  <div id="tournament" :class="[reloadTournament]">
    <banner :model="banner_images"></banner>
    <div class="details align-hor space-between bg-light padding-10 margin-5">
      <div style="width: 30%">
        <div class="align-hor center-hor center-hor margin-bottom-10">
          <img class="small-icon margin-right-5" src="@/assets/timer.svg" style="margin-top: 6px;">
          <p class="text-small">{{getTranslatedText('Game Time')}}</p>
        </div>
        <div class="pos-rel align-hor center-ver center-hor" v-if="hasStartEndDateTime">
          <div class="text-semi-small text-uppercase margin-right-15">
            <p class="no-margin">{{tournamentTiming.start.time}}</p>
            <p class="no-margin text-lighter-grey text-small">{{tournamentTiming.start.date}}</p>
          </div>
          <div class="pos-abs pos-center-ver pos-center-hor padding-top-10">-</div>
          <div class="text-semi-small text-uppercase pull-right">
            <p class="no-margin">{{tournamentTiming.end.time}}</p>
            <p class="no-margin text-lighter-grey text-small">{{tournamentTiming.end.date}}</p>
          </div>
        </div>
        <div class="wrapper" v-else>
          <div class="comment animate bg-light-grey margin-bottom-20"></div>
          <div class="comment animate bg-light-grey"></div>
        </div>
      </div>
      <div style="width: 45%">
        <div class="container text-light">
          <img class="icon-120" src="@/assets/ticket-colored.svg">
          <div class="centered text-extra-large">
            {{gameData.tournament.total_prize}}
            <div class="text-small text-uppercase">{{getTranslatedText(gameData.tournament.prize_type)}}</div>
          </div>
        </div>
        <div class="text-light-grey" v-if="hasJoined" v-on:click="tournamentData.leaderboard = !tournamentData.leaderboard">Your rank <span class="text-semi-large text-green text-underline">#{{currentRank}}</span></div>

        <div class="modal center-hor align-ver" v-show="tournamentData.leaderboard" v-on:click="tournamentData.leaderboard = !tournamentData.leaderboard">
          <leader-board v-show="tournamentData.leaderboard" :model="tournamentData.leaderboard_data"></leader-board>
        </div>
      </div>
      <div style="width: 25%">
        <div class="align-hor center-hor margin-bottom-10">
          <img class="smaller-icon margin-right-5" src="@/assets/user.svg" style="margin-top: 6px;">
          <p class="text-small">{{getTranslatedText('Players joined')}}</p>
        </div>
        <div class="text-uppercase" v-if="hasPlayersJoined">{{tournamentData.live_players}}/{{tournamentData.max_players}}</div>
        <div class="wrapper" v-else>
          <div class="animate comment"></div>
          <div class="animate comment"></div>
        </div>
      </div>
    </div>
    <custom-marquee></custom-marquee>
    <div class="prizes margin-5">
      <div class="header text-uppercase padding-10 margin-bottom-5 text-dark bg-dark-grey">{{getTranslatedText('prizes')}}</div>
      <div class=" padding-20 bg-light">
        <table class="ranking-prizes text-regular">
          <tr>
          <th colspan="2" class="font-medium text-center padding-horizontal-10 font-bold">
            <img class="smaller-icon margin-right-5" src="@/assets/trophy.svg">{{gameData.tournament.winner_percent}}% {{getTranslatedText('Winners')}}
          </th>
          </tr>
          <tr v-for="prize in prizes">
            <td class="text-left" v-if="prize.from_rank == prize.to_rank">{{getTranslatedText('Rank')}}: {{prize.from_rank}}</td>
            <td class="text-left" v-else>{{getTranslatedText('Rank')}}: {{prize.from_rank}} {{getTranslatedText('to')}} {{prize.to_rank}}</td>
            <td class="text-right">{{prize.prize}} {{getTranslatedText(prize.prize_type)}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="rules margin-5 bg-light">
      <div style="padding:10px; margin-top: 15px" class="text-left padding-vertical-5 text-dark font-bold bg-dark-grey text-center">{{getTranslatedText('rules')}}</div>
      <div v-if="Array.isArray(gameData.tournament.rules)">
        <ol class="list-of-rules text-left padding-15">
          <li class="text-semi-small text-light-grey" v-for="rule in gameData.tournament.rules" v-html="rule">
          </li>
        </ol>
      </div>
      <div style="margin-left: 5px; margin-right: 5px;" v-else>
        <span class="text-left" v-html="gameData.tournament.rules"></span>
      </div>
    </div>

    <div class="fixed-bottom bg-light padding-20 top-border-light-grey">
      <div v-if="gameData.tournament.is_live">
        <div v-if="chancesLeft >= 0" style="padding-bottom: 3px">{{chancesLeft}} chance(s) left</div>
        <button class="custom-button text-uppercase radius-5 padding-1520 text-light font-bold text-large margin-bottom-5" v-on:click.stop.prevent="redirectToGame(gameData.tournament.id)" v-if="gameData.tournament.is_live" :style="{background: bgTheme}">{{getTranslatedText('play')}}</button>
        <div class="text-light-grey text-semi-small">{{getTranslatedText('Game ends in')}} <span class="text-red">{{countDown}}</span></div>
      </div>
      <button class="custom-button timer radius-5 padding-1520 text-light text-large" v-else>{{getTranslatedText('Game starts in')}} {{countDown}}</button>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  import Banner from '@/components/banner'
  import Marquee from '@/components/custom-marquee'
  import LeaderBoard from '@/components/leader-board'
  export default {
    mixins: [globals],
    components: {
      'banner': Banner,
      'custom-marquee': Marquee,
      'leader-board': LeaderBoard,
    },
    data() {
      return {
        gameData: {
          tournament: {
            total_prize: 0
          },
        },
        tournament: {},
        prizes: [],
        banner_images: "",
        tournamentTiming: {
          start: {
            time: '',
            date: ''
          },
          end: {
            time: '',
            date: ''
          }
        },
        countDownTimer: "",
      }
    },
    computed: {
      hasStartEndDateTime: function() {
        var timing = this.tournamentTiming;
        if(timing.start.time && timing.start.date && timing.end.time && timing.end.date) {
          return true;
        } else {
          return false;
        }
      },
      hasPlayersJoined: function() {
        var td = this.tournamentData;
        if(td.live_players >= 0 && td.max_players > 0) {
          return true;
        } else {
          return false;
        }
      },
      reloadTournament: function() {
        if(this.$store.state.refreshTournament) {
          this.fetchTournamentData();
        }
      },
      tournamentData: function() {
        return this.tournament;
      }
    },
    methods: {
      fetchTournamentData() {
        var self = this;
        var game_id = '';
        self.$store.state.partner = self.$route.query.partner;
        self.$store.state.user.phone = self.$route.query.contact_number;
        if(self.$route.query.hasOwnProperty('user_name')) {
          self.$store.state.user.name = self.$route.query.user_name;
        }

        if(self.$route.query.hasOwnProperty('game_id')) {
          self.$store.state.game = self.$route.query.game_id;
        } else {
          self.$store.state.game = game_id;
        }

        if(self.$route.query.hasOwnProperty('lang')) {
          self.$store.state.lang = self.$route.query.lang;
        } else {
          self.$store.state.lang = "en";
        }

        if(self.isValidRequest) {
          var flyy_url = this.$store.getters.flyyDomain+'/bg_theme?partner='+self.partnerID;

          var url = this.$store.getters.gamesDomain+'/v2/web_games?partner='+self.partnerID+'&contact_number='+self.extUid+'&user_name='+self.userName;
          if(self.gameID) {
            url += "&game_id="+self.gameID;
          }
          if(self.langCode) {
            url += "&lang="+self.langCode;
          }
          var headers = this.$store.getters.headers;

          const bg_them_url = axios.get(flyy_url);
          const games_url = axios.get(url);

          axios.all([bg_them_url, games_url], {
            headers: headers
          }).then((responses) => {
            var flyy_resp = responses[0];
            var resp = responses[1];
            if(flyy_resp.status == 200 && flyy_resp.data.success) {
              var data = flyy_resp.data;
              if (!self.$store.state.bg_theme || self.$store.state.bg_theme.length == 0) {
                self.$store.state.bg_theme = data.bg_theme
              }
              if(this.$ls.get("userData") != null) {
                var user_data = JSON.parse(this.$ls.get("userData"));
                user_data.bg_theme = data.bg_theme;
                this.$ls.set('userData', JSON.stringify(user_data));
              }
            }

            if(resp.status == 200) {
              self.$store.state.totalUserPoints = resp.data.total_user_points;
            }
            if(resp.status == 200 && resp.data.success) {
              var data = resp.data;
              var game_data = data.game;
              self.$store.state.user.chancesLeft = game_data.tournament.plays_left;
              self.$store.state.gameName = game_data.name;
              self.$store.state.headTitle = game_data.name;
              self.$store.state.wallet.type = data.wallet_type;
              var gt = game_data.tournament;
              gt.leaderboard = false;
              var tempObj = {}
              tempObj.id = gt.your_id;
              tempObj.name = gt.your_name;
              tempObj.mobile = gt.your_contact_number;
              tempObj.rank = gt.your_rank;
              tempObj.prize = gt.your_prize;
              tempObj.score = gt.your_score;
              tempObj.prize_type = gt.your_prize_type;
              game_data.tournament.leaderboard_data.unshift(tempObj);
              self.tournament = game_data.tournament;
              self.gameData = game_data;
              self.prizes = game_data.tournament.prizes;
              self.banner_images = game_data.wall_url;
              self.tournamentTiming = self.getFormattedDateTime(game_data.tournament.starts_at, game_data.tournament.ends_at)
              self.$store.state.user.joined = gt.joined;
              self.$store.state.user.rank = gt.your_rank;

              if(gt.joined) {
                self.messageToShare(gt.your_prize, gt.your_prize_type, gt.title);
              }

              if(game_data.tournament.is_live) {
                self.$store.state.timer = setInterval(function() {
                  self.getTimer(true, game_data.tournament.ends_at);
                }, 1000);
              } else {
                self.$store.state.timer = setInterval(function() {
                  self.getTimer(false, game_data.tournament.starts_at);
                }, 1000);
              }
              if(this.$ls.get("userData") != null) {
                var user_data = JSON.parse(this.$ls.get("userData"));
                user_data.tournamentID = gt.id;
                user_data.joined = gt.joined;
                user_data.rank = gt.your_rank;
                this.$ls.set('userData', JSON.stringify(user_data));
              }

              // console.log("~~~~~~~~~~interval~~"+self.$store.state.refreshTournamentTimer)
              if (self.$store.state.refreshTournamentTimer == null) {
                self.$store.state.refreshTournamentTimer = setInterval(function() {
                  self.refreshLeaderBoardData();
                }, 5000);
              }
              // console.log("~~~~~~~~~~interval1~~"+self.$store.state.refreshTournamentTimer)
            } else {
              self.alertPopup(true, resp.data.message);
            }
          }).catch((err) => {});

          if(this.$ls.get("userData") != null) {
            var user_data = JSON.parse(this.$ls.get("userData"));
            user_data.name = self.$route.query.user_name ? self.$route.query.user_name : "";
            user_data.phone = self.$route.query.contact_number;
            user_data.partnerID = self.$route.query.partner;
            if(self.$route.query.hasOwnProperty('game_id')) {
              user_data.gameID = self.$route.query.game_id;
            } else {
              user_data.gameID = "";
            }
            if(self.$route.query.hasOwnProperty('lang') && self.$route.query.lang.length > 0) {
              user_data.langCode = self.$route.query.lang;
            } else {
              user_data.langCode = "en";
            }
            this.$ls.set('userData', JSON.stringify(user_data));
          }
        } else {
          self.alertPopup(true, "Invalid request!");
        }
      },
      redirectToGame(id) {
        var self = this;
        if(self.isValidRequest && id) {
          self.$store.state.isInfo = true;
          self.tournament.is_live = true;

          var msg = this.getTranslatedText("please_wait_text");
          self.alertPopup(true, msg);
          var url = this.$store.getters.gamesDomain+'/v2/play_tournament?partner='+self.partnerID+'&contact_number='+self.extUid+'&tournament_id='+id;
          var headers = this.$store.getters.headers;

          axios.get(url, {
            headers: headers
          }).then((resp) => {
            if(resp.status == 200 && resp.data.success) {
              var data = resp.data;
              self.closeAlert();
              //static true added by Abhinav to always open the game in iframe so that the game play duration can be calculated
              if(true) {
                // var params = {
                //   url: data.game_url,
                //   is_landscape: data.is_landscape,
                //   partner_id: self.partnerID,
                //   contact_number: self.extUid,
                //   tr_id: id
                // }

                // self.redirectTo("game", params);
                var url = `https://web-games.appbrowzer.com/game?url=${encodeURIComponent(data.game_url)}&is_landscape=${data.is_landscape}&partner_id=${self.partnerID}&contact_number=${self.extUid}&tr_id=${id}`;
                // console.log(url);
                window.location = url;
              } else {
                window.location = data.game_url;
              }
            } else {
              self.alertPopup(true, resp.data.message);
            }
          }).catch((err) => {})
        }
      },
      refreshLeaderBoardData() {
        var self = this;
        var id;
        if(this.$ls.get("userData") != null) {
          var user_data = JSON.parse(this.$ls.get("userData"));
          id = user_data.tournamentID;
        }
        self.$store.state.partner = self.$route.query.partner;
        if(self.isValidRequest && id) {
          var url = this.$store.getters.gamesDomain+'/v2/live_tournament_v1?partner='+self.partnerID+'&contact_number='+self.extUid+'&tr_id='+id;
          var headers = this.$store.getters.headers;

          axios.get(url, {
            headers: headers
          }).then((resp) => {
            if(resp.status == 200 && resp.data.success) {
              var data = resp.data;
              var gt = data.tournament;
              self.$store.state.user.chancesLeft = gt.plays_left;
              var tempObj = {}
              tempObj.id = gt.your_id;
              tempObj.name = gt.your_name;
              tempObj.mobile = gt.your_contact_number;
              tempObj.rank = gt.your_rank;
              tempObj.prize = gt.your_prize;
              tempObj.score = gt.your_score;
              tempObj.prize_type = gt.your_prize_type;
              gt.leaderboard_data.unshift(tempObj);
              gt.leaderboard = (self.tournamentData.leaderboard) ? true : false;
              self.tournament = gt;
              self.$store.state.user.joined = gt.joined;
              self.$store.state.user.rank = gt.your_rank;

              if(gt.joined) {
                self.messageToShare(gt.your_prize, gt.your_prize_type, gt.title);
              }
              if(this.$ls.get("userData") != null) {
                var user_data = JSON.parse(this.$ls.get("userData"));
                user_data.joined = gt.joined;
                user_data.rank = gt.your_rank;
                this.$ls.set('userData', JSON.stringify(user_data));
              }

            }
          }).catch((err) => {})
        } else {
          console.log("Invalid request!!!!");
        }
      },
    },
    created() {
      if(this.$route.query.hasOwnProperty('contact_number')) {
        this.$store.state.user.phone = this.$route.query.contact_number;
      }
      if(this.$route.query.hasOwnProperty('partner')) {
        // this.$store.state.partner = this.$route.query.partner;
      }
      if(this.$route.query.hasOwnProperty('game_id')) {
        this.$store.state.game = this.$route.query.game_id;
      }
      clearInterval(this.$store.state.refreshTournamentTimer);
      if (this.$route.query.hasOwnProperty('lang') && this.$route.query.lang.length > 0) {
        this.$store.state.lang = this.$route.query.lang;
      } else {
        this.$store.state.lang = "en"
      }
      if (this.$store.state.headTitle.length > 0) {
        this.$store.state.headTitle = this.$store.state.gameName;
      }
      this.$store.state.showHeader = true;
      this.$store.state.showHistory = true;
      this.$store.state.showWallet = true;
      this.refreshLeaderBoardData();
      this.fetchTournamentData();
    }
  }
</script>

<style>
  #tournament {
    margin-bottom: 130px;
  }
  #tournament .ranking-prizes {
    border-collapse: collapse;
    width: 100%;
  }
  #tournament .ranking-prizes td {
    padding: 8px 15px;
  }
  #tournament .ranking-prizes tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  .list-of-rules {
    padding: 0 0 0 10px;
    list-style-type: none;
  }
  .list-of-rules li {
    counter-increment: step-counter;
    margin-bottom: 10px;
    padding-left: 30px;
  }
  .list-of-rules li:before {
    content: counter(step-counter);
    margin-left: -25px;
    margin-right: 7px;
    font-size: 80%;
    background-color: #f0f0f0;
    font-weight: bold;
    padding: 5px 7px;
    border-radius: 50%;
    width: 13px;
    height: 13px;
  }

  .small-icon {
    width: 20px;
    height: 20px;
  }
  .smaller-icon {
    width: 15px;
    height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/tournament.vue